export default __webpack_public_path__ + "static/media/Commander's Belt of the Warring States.7f66b8d6.jpg";